module.exports = __webpack_public_path__ + "img/company_casetwo.3bb6114e.svg";